(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.KoModel = (function(superClass) {
    extend(KoModel, superClass);

    function KoModel() {
      KoModel.__super__.constructor.call(this);
      this.handler = null;
      this.ignore('handler');
      this.transform(function(v) {
        if (ko.isObservable(v) || ko.isComputed(v)) {
          v = v();
        }
        return v;
      });
      this.registerCustomBindings();
    }

    KoModel.prototype.serialize = function() {
      return ko.toJSON(this._cleanUp());
    };

    KoModel.prototype.toJS = function() {
      return ko.toJS(this._cleanUp());
    };

    KoModel.prototype.registerCustomBindings = function() {
      return void 0;
    };

    return KoModel;

  })(DependencyInjection);

}).call(this);
